'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var lodash = require('lodash');
var cn = require('classnames');
var Box = require('@material-ui/core/Box');
var Paper = require('@material-ui/core/Paper');
var Typography = require('@material-ui/core/Typography');
var styles = require('@material-ui/core/styles');
var Avatar = require('@material-ui/core/Avatar');
var tooltips = require('@scoir/tooltips');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
var Paper__default = /*#__PURE__*/_interopDefaultLegacy(Paper);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var AvatarIconColor = {
  none: 'none',
  "default": 'default',
  error: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info',
  secondary: 'secondary',
  inverted: 'inverted'
};
var ICON_COLOR = AvatarIconColor;
var useStyles$1 = styles.makeStyles(function (theme) {
  var _ref;

  var xl = theme.spacing(16);
  var lg = theme.spacing(10);
  var md = theme.spacing(7);
  var sm = theme.spacing(5);
  var xs = theme.spacing(3);
  return _ref = {
    xl: {
      height: xl,
      width: xl
    },
    lg: {
      height: lg,
      width: lg
    },
    md: {
      height: md,
      width: md
    },
    sm: {
      height: sm,
      width: sm
    },
    xs: {
      height: xs,
      width: xs
    }
  }, _defineProperty(_ref, AvatarIconColor.none, {
    // none
    backgroundColor: 'transparent',
    color: '#ddd'
  }), _defineProperty(_ref, AvatarIconColor["default"], {
    // default
    backgroundColor: '#F5F5F5',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.action.disabled
  }), _defineProperty(_ref, AvatarIconColor.error, {
    // error
    backgroundColor: '#F4433614',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.error.main
  }), _defineProperty(_ref, AvatarIconColor.warning, {
    // warning
    backgroundColor: '#ED6C0214',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.warning.main
  }), _defineProperty(_ref, AvatarIconColor.success, {
    // success
    backgroundColor: '#587F1B14',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.success.main
  }), _defineProperty(_ref, AvatarIconColor.info, {
    // info
    backgroundColor: '#2196F314',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.info.dark
  }), _defineProperty(_ref, AvatarIconColor.secondary, {
    // secondary
    backgroundColor: '#745CA114',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.secondary.main
  }), _defineProperty(_ref, AvatarIconColor.inverted, {
    // inverted
    backgroundColor: '#0A6BB8',
    color: theme.palette.common.white
  }), _ref;
});
var DEFAULT_AVATAR_PROPS = {
  variant: 'square',
  alt: 'avatar'
};

function AvatarWithFallback(_a) {
  var component = _a.component,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'md' : _a$size,
      _a$classes = _a.classes,
      classes = _a$classes === void 0 ? {} : _a$classes,
      sourceUrl = _a.sourceUrl,
      fallbackUrl = _a.fallbackUrl,
      fallbackIcon = _a.fallbackIcon,
      _a$iconColor = _a.iconColor,
      iconColor = _a$iconColor === void 0 ? AvatarIconColor.none : _a$iconColor,
      rest = __rest(_a, ["component", "size", "classes", "sourceUrl", "fallbackUrl", "fallbackIcon", "iconColor"]);

  var classNames = useStyles$1();
  var Component = component || Avatar__default["default"];
  return /*#__PURE__*/React__default["default"].createElement(Component, Object.assign({}, DEFAULT_AVATAR_PROPS, rest, {
    classes: Object.assign({
      root: classNames[size],
      colorDefault: classNames[iconColor]
    }, classes),
    src: sourceUrl
  }), fallbackIcon || /*#__PURE__*/React__default["default"].createElement(Component, Object.assign({}, DEFAULT_AVATAR_PROPS, rest, {
    classes: Object.assign({
      root: classNames[size]
    }, classes),
    src: fallbackUrl
  }), "\xA0"));
}

var DATA_POINT_WHITE = 'white';
var DATA_POINT_BLUE = 'blue';
var useStyles = styles.makeStyles(function (theme) {
  return {
    defaultTheme: {
      backgroundColor: 'transparent'
    },
    whiteTheme: {
      backgroundColor: 'white'
    },
    blueTheme: {
      backgroundColor: lodash.get(theme, 'palette.info.dark'),
      color: 'white'
    },
    squareBottomCorners: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    avatar: {
      width: theme.spacing(5),
      height: theme.spacing(5)
    },
    disabledColor: {
      color: styles.lighten(lodash.get(theme, 'palette.text.primary'), 0.44)
    }
  };
});

var DataPoint = function DataPoint(_ref) {
  var _ref2;

  var avatarProps = _ref.avatarProps,
      datum = _ref.datum,
      disabled = _ref.disabled,
      iconButton = _ref.iconButton,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      squareBottomCorners = _ref.squareBottomCorners,
      title = _ref.title,
      theme = _ref.theme,
      tooltipContents = _ref.tooltipContents;
  var classes = useStyles();
  var isBlueTheme = !disabled && theme === DATA_POINT_BLUE;
  var isWhiteTheme = theme === DATA_POINT_BLUE && disabled || theme === DATA_POINT_WHITE;
  var isDefaultTheme = !isWhiteTheme && !isBlueTheme;
  var className = cn__default["default"]([(_ref2 = {}, _ref2[classes.whiteTheme] = isWhiteTheme, _ref2[classes.blueTheme] = isBlueTheme, _ref2[classes.defaultTheme] = isDefaultTheme, _ref2[classes.squareBottomCorners] = squareBottomCorners, _ref2[classes.disabledColor] = disabled, _ref2), styles.root]);
  return /*#__PURE__*/React__default["default"].createElement(Paper__default["default"], {
    className: className,
    elevation: 0
  }, /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    p: 2,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: iconButton ? 'space-between' : 'normal'
  }, !lodash.isEmpty(avatarProps) && /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    mr: 2
  }, /*#__PURE__*/React__default["default"].createElement(AvatarWithFallback, _extends({
    className: classes.avatar,
    iconColor: isBlueTheme ? ICON_COLOR["default"] : ICON_COLOR.info,
    variant: "circular"
  }, avatarProps))), /*#__PURE__*/React__default["default"].createElement(Box__default["default"], null, /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
    component: "span",
    variant: "body2",
    color: isBlueTheme ? 'initial' : !disabled ? 'textSecondary' : undefined,
    className: styles.title
  }, title, ' ', tooltipContents && /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    display: "inline-block",
    ml: 1
  }, /*#__PURE__*/React__default["default"].createElement(tooltips.Info, {
    outlinedIcon: true,
    inheritColor: true
  }, tooltipContents)))), /*#__PURE__*/React.isValidElement(datum) ? datum : /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
    variant: "h5"
  }, datum || 'Not Reported')), iconButton && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.iconBtnWrapper
  }, iconButton)));
};

DataPoint.propTypes = {
  title: PropTypes__default["default"].string.isRequired,
  datum: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].element]),
  tooltipContents: PropTypes__default["default"].node,
  avatarProps: PropTypes__default["default"].object,
  theme: PropTypes__default["default"].oneOf([DATA_POINT_WHITE, DATA_POINT_BLUE]),
  disabled: PropTypes__default["default"].bool,
  squareBottomCorners: PropTypes__default["default"].bool,
  styles: PropTypes__default["default"].shape({
    iconBtnWrapper: PropTypes__default["default"].string,
    root: PropTypes__default["default"].string,
    title: PropTypes__default["default"].string
  }),
  iconButton: PropTypes__default["default"].element
};

exports.DATA_POINT_BLUE = DATA_POINT_BLUE;
exports.DATA_POINT_WHITE = DATA_POINT_WHITE;
exports.DataPoint = DataPoint;
//# sourceMappingURL=index.module.js.map
